import { useState } from "react";
import { Bed, Settings, Baby } from "lucide-react";
import { Tabs, TabPanel, type Tab } from "@/components/ui/Tabs";
import { BedBoard } from "@/features/shelter/BedBoard";
import { BedManagement } from "@/features/shelter/BedManagement";
import { CribManagement } from "@/features/shelter/CribManagement";

const shelterTabs: Tab[] = [
  { id: "board", label: "Bed Board", icon: Bed },
  { id: "cribs", label: "Cribs", icon: Baby },
  { id: "manage", label: "Manage Beds", icon: Settings },
];

export function ShelterPage() {
  const [activeTab, setActiveTab] = useState("board");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">Shelter</h1>
        <p className="text-sm text-muted-foreground">
          Manage bed inventory and track occupancy in real time.
        </p>
      </div>

      <Tabs tabs={shelterTabs} activeTab={activeTab} onChange={setActiveTab} />

      <TabPanel id="board" activeTab={activeTab}>
        <BedBoard />
      </TabPanel>

      <TabPanel id="cribs" activeTab={activeTab}>
        <CribManagement />
      </TabPanel>

      <TabPanel id="manage" activeTab={activeTab}>
        <BedManagement />
      </TabPanel>
    </div>
  );
}
